import React from "react";
import PropTypes from "prop-types";
const PlusStandardisedIcon = ({
  noPointer,
  width,
  size,
  height,
  style,
  color,
  rotate,
  title,
  ...props
}) => {
  const finalStyle = {
    transform: `rotate(${rotate || 0}deg)`,
    ...style
  };

  return (
    <svg
      {...props}
      style={finalStyle}
      data-no-pointer={noPointer}
      width={width || size || 20}
      height={height || size || 20}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="title"
    >
      <title>{title}</title>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h20v20H0z" />
        <g fill={color || "var(--color-easil-gray-x-dark)"} fillRule="nonzero">
          <path d="M9 1a1 1 0 1 1 2 0v18a1 1 0 1 1-2 0V1z" />
          <path d="M1 11a1 1 0 1 1 0-2h18a1 1 0 0 1 0 2H1z" />
        </g>
      </g>
    </svg>
  );
};
PlusStandardisedIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string,
  rotate: PropTypes.string
};

export default PlusStandardisedIcon;
